/**
 * DUBAI AROMA — LUXURY ENHANCEMENTS JS
 * Micro-interactions and luxury UI behaviors
 */

(function () {
  'use strict';

  /* ============================================
     1. HEADER — GLASS MORPHISM ON SCROLL
     ============================================ */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var SCROLL_THRESHOLD = 60;

    function updateHeader() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader(); // apply on initial load
  }

  /* ============================================
     2. HERO IMAGE — SUBTLE SCALE-IN ON LOAD
     ============================================ */
  document.querySelectorAll('.banner__media img').forEach(function (img) {
    if (img.complete) {
      img.classList.add('lux-parallax-ready');
    } else {
      img.addEventListener('load', function () {
        img.classList.add('lux-parallax-ready');
      });
    }
  });

  /* ============================================
     3. PRODUCT GRID — STAGGER REVEAL
     Cards are visible by default. JS adds the
     hidden class to the PARENT grid first, then
     reveals cards one-by-one. If JS fails, all
     cards remain visible — no FOIC.
     ============================================ */
  function revealGrid(grid) {
    /* Mark grid so CSS hides its cards */
    grid.classList.add('lux-stagger-grid');
    var cards = grid.querySelectorAll('.modern-card-wrapper');

    /* If grid is already in viewport, reveal immediately with stagger */
    cards.forEach(function (card, i) {
      setTimeout(function () {
        card.classList.add('lux-card-visible');
      }, i * 80);
    });
  }

  if (window.IntersectionObserver) {
    var cardObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealGrid(entry.target);
          cardObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.01, rootMargin: '0px 0px -20px 0px' }
    );

    /* Target every known grid container — collection page, featured collection, homepage */
    var gridSelectors = [
      '#product-grid',
      '.collection__grid',
      '.featured-collection .grid',
      '.related-products .grid',
      '.collection-list .grid'
    ];

    document.querySelectorAll(gridSelectors.join(', ')).forEach(function (grid) {
      var rect = grid.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        /* Already visible — reveal immediately */
        revealGrid(grid);
      } else {
        cardObserver.observe(grid);
      }
    });
  }
  /* No IntersectionObserver fallback: cards stay visible (no lux-stagger-grid added) */

  /* ============================================
     4. SECTION HEADINGS — FADE UP ON SCROLL
     Only applied to headings below the fold.
     ============================================ */
  if (window.IntersectionObserver) {
    var headingObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lux-heading-visible');
            headingObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );

    document.querySelectorAll('.collection__title, .title-wrapper').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      /* Only animate headings that START below the fold */
      if (rect.top > window.innerHeight) {
        el.classList.add('lux-heading-init');
        headingObserver.observe(el);
      }
    });
  }

  /* ============================================
     5. PRODUCT IMAGE — MAGNETIC HOVER
     (desktop: subtle pan on mousemove)
     ============================================ */
  if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
    document.querySelectorAll('.modern-card__media').forEach(function (media) {
      var img = media.querySelector('img.primary-image');
      if (!img) return;

      media.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * 6;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * 6;
        img.style.transform = 'scale(1.06) translate(' + x + 'px, ' + y + 'px)';
      });

      media.addEventListener('mouseleave', function () {
        img.style.transform = '';
      });
    });
  }

  /* ============================================
     6. CART COUNT — PULSE ANIMATION ON ADD
     ============================================ */
  document.addEventListener('cart:updated', function () {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.add('lux-pulse');
    setTimeout(function () { bubble.classList.remove('lux-pulse'); }, 600);
  });

})();
